import { styled } from '@mui/material';

export const H2Styled = styled('h3')(({ theme }) => ({
  paddingTop: theme.spacings.unit(9),
  color: theme.colors.primaryText,
  fontSize: theme.fonts.utility.size(10),
  fontWeight: 600,
  margin: 0,
}));
